const getDiffText = (diffInDays: number): string => {
  if (diffInDays < 31) {
    return ` (in ${diffInDays} days)`
  }
  return ''
}

export default getDiffText
